/**
 * RoleOnlyModal
 * 역할 제한 안내 팝업 - 공통 컴포넌트
 *
 * Props:
 *   title         - 모달 제목
 *   message       - 안내 메시지
 *   onClose       - 닫기 핸들러
 *   onboardingPath - 온보딩 경로 (계정 생성 버튼 표시 시 필요)
 *   onboardingLabel - 온보딩 버튼 텍스트 (기본: "계정 만들러 가기")
 *   hasBothRoles  - 두 역할 모두 보유 여부 (전환 버튼 표시 시 true)
 *   onSwitch      - 역할 전환 핸들러 (hasBothRoles가 true일 때 사용)
 *   switchLabel   - 전환 버튼 텍스트 (기본: "계정 전환하기")
 */
export default function RoleOnlyModal({ title, message, onClose, onboardingPath, onboardingLabel, hasBothRoles, onSwitch, switchLabel }) {
  const btn = { fontFamily: 'Pretendard, sans-serif', fontWeight: 600, fontSize: '16px', letterSpacing: '-0.04em', cursor: 'pointer', border: 'none', borderRadius: '10px', width: '100%', height: '52px' };

  const ALLOWED_PATHS = ['/onboarding/talent', '/onboarding/producer'];

  const handleOnboarding = () => {
    if (!onboardingPath || !ALLOWED_PATHS.includes(onboardingPath)) return;
    onClose();
    window.location.href = onboardingPath;
  };

  const handleSwitch = () => {
    onClose();
    onSwitch?.();
  };

  return (
    <div
      onClick={onClose}
      style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 99999 }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{ background: '#FFFFFF', borderRadius: '20px', padding: '60px 50px', width: '480px', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '32px' }}
      >
        <div style={{ width: '54px', height: '54px', background: '#FFFBD5', borderRadius: '30px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="8" r="4" stroke="#FFA40D" strokeWidth="2" strokeLinecap="round"/>
            <path d="M5 20c0-3.9 3.1-7 7-7s7 3.1 7 7" stroke="#FFA40D" strokeWidth="2" strokeLinecap="round"/>
          </svg>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '12px' }}>
          <span style={{ fontFamily: 'Pretendard, sans-serif', fontWeight: 600, fontSize: '24px', letterSpacing: '-0.04em', textAlign: 'center', color: '#090909' }}>
            {title}
          </span>
          <span style={{ fontFamily: 'Pretendard, sans-serif', fontWeight: 400, fontSize: '16px', lineHeight: '150%', letterSpacing: '-0.04em', textAlign: 'center', color: '#555555', whiteSpace: 'pre-line' }}>
            {message}
          </span>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', width: '100%' }}>
          {/* 두 역할 모두 보유 → 전환 버튼 (primary) */}
          {hasBothRoles && onSwitch && (
            <button onClick={handleSwitch} style={{ ...btn, background: '#090909', color: '#FFFFFF' }}>
              {switchLabel || '계정 전환하기'}
            </button>
          )}
          {/* 해당 역할 계정 없음 → 온보딩 버튼 */}
          {!hasBothRoles && onboardingPath && (
            <button onClick={handleOnboarding} style={{ ...btn, background: '#090909', color: '#FFFFFF' }}>
              {onboardingLabel || '계정 만들러 가기'}
            </button>
          )}
          {/* 닫기 버튼 */}
          <button
            onClick={onClose}
            style={{ ...btn, background: hasBothRoles || onboardingPath ? '#F3F3F5' : '#090909', color: hasBothRoles || onboardingPath ? '#555555' : '#FFFFFF', border: '1px solid #E9E9EC' }}
          >
            {hasBothRoles || onboardingPath ? '닫기' : '확인'}
          </button>
        </div>
      </div>
    </div>
  );
}
